<template>
  <WowzaList />
</template>

<script>
import WowzaList from '@/components/wowza/WowzaList.vue';


export default {
  components: {
    WowzaList
  }

}
</script>

<style lang="scss" scoped></style>